<nav class="subnav">
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/job/details/', projectId, jobId]">Zum Job</a>
    </li>
  </ul>
</nav>

<main *ngIf="!!person">
  <h2>Auftragsbestätigung {{ projectId }}.0008.{{ confirmationId }}</h2>
  <p *ngIf="!loading1">
    <span class="label label-light-blue">Job vom: {{ confirmation.job_date | date: 'dd.MM.yyyy'  }}</span>
  </p>

  <div class="spinner" *ngIf="loading1">Loading data</div>
  <div class="clr-row">
    <div class="clr-col-lg-12 clr-col-md-12 clr-col-12">
      <div class="card">
        <div class="card-header">
          {{ confirmation.name_project }}
        </div>
        <div class="card-block">
          <div class="card-text">
            <clr-tabs>
              <clr-tab>
                <button clrTabLink>Übersicht</button>
                <clr-tab-content clrTabContentId="content1">
                  <br>
                  <div class="clr-row">
                    <div class="clr-col-3">
                      Kunde
                    </div>
                    <div class="clr-col-8">
                      {{ confirmation.company_name }}<br />{{ confirmation.street }}<br />{{ confirmation.postcode }} {{ confirmation.city }}
                      <span *ngIf="confirmation.country !== 'Deutschland'">{{ confirmation.country }}</span>
                    </div>
                    <div class="clr-col-1">
                      <cds-icon shape="note" [routerLink]="['/contact/details', companyId ]"></cds-icon>
                    </div>
                  </div>
                  <div class="clr-row">
                    <div class="clr-col-3">
                      Bestellnummer des Kunden:
                    </div>
                    <div class="clr-col-9">
                      {{ confirmation.order_id }}
                    </div>
                  </div>
                  <div class="clr-row">
                    <div class="clr-col-3">
                      Ansprechpartner beim Kunden:
                    </div>
                    <div class="clr-col-8">
                      {{ personSalutation }} {{ personFirstName }} {{ personLastName }}
                    </div>
                    <div class="clr-col-1">
                      <cds-icon shape="note" [routerLink]="['/person/details', personId ]"></cds-icon>
                    </div>
                  </div>
                  <div class="clr-row">
                    <div class="clr-col-3">
                      Angebotsbedingungen:
                    </div>
                    <div class="clr-col-9">
                      {{ offerCondition }}
                    </div>
                  </div>
                  <div class="clr-row">
                    <div class="clr-col-3">
                      Zahlungsbedingungen:
                    </div>
                    <div class="clr-col-9">
                      {{ paymentCondition }}
                    </div>
                  </div>
                  <div class="clr-row">
                    <div class="clr-col-3">
                      Lieferung:
                    </div>
                    <div class="clr-col-9">
                      {{ deliveryCondition }}
                    </div>
                  </div>
                  <div *ngIf="confirmation.cond_delivery === 3" class="clr-row">
                    <div class="clr-col-3">
                      Lieferadresse:
                    </div>
                    <div class="clr-col-9" *ngIf="!!confirmation.delivery_company">
                      {{ confirmation.delivery_company }}<br />
                      <span *ngIf="confirmation.delivery_department">{{ confirmation.delivery_department }}<br /></span>
                      {{ confirmation.delivery_street }}<br />
                      {{ confirmation.delivery_postcode }} {{ confirmation.delivery_city }}<br />
                      {{ confirmation.delivery_country }}
                    </div>
                  </div>
                  <div class="clr-row">
                    <div class="clr-col-3">
                      Bemerkungen zur Lieferzeit:
                    </div>
                    <div class="clr-col-9">
                      {{ confirmation.delivery_remarks }}
                    </div>
                  </div>
                  <div class="clr-row">
                    <div class="clr-col-3">
                      Lieferdatum:
                    </div>
                    <div class="clr-col-9">
                      <span *ngIf="confirmation.delivery_date !== '0000-00-00'">{{ confirmation.delivery_date | date: "dd.MM.yyyy" }}</span>
                      <span *ngIf="confirmation.delivery_date === '0000-00-00'">---</span>
                    </div>
                  </div>
                  <br />
                  <div class="btn-group btn-sm btn-primary">
                    <button class="btn" [routerLink]="['/confirmation/update', projectId, jobId, confirmationId]">Auftragsbestätigung bearbeiten</button>
                    <button class="btn btn-warning" (click)="deleteConfirmation(projectId, confirmationId)">Auftragsbestätigung löschen</button>
                  </div>

                  <clr-datagrid *ngIf="editPos < 2" [clrDgLoading]="loading2" [(clrDgSelected)]="selected" [clrDgRowSelection]="true">
                    <clr-dg-action-bar *ngIf="(editPos < 2)">
                      <div class="btn-group">
                        <button type="button" class="btn btn-sm btn-danger-outline" (click)="onDelete()" ><cds-icon shape="minus-circle"></cds-icon> Postionen löschen</button>
                      </div>
                    </clr-dg-action-bar>
                    <clr-dg-column>Position</clr-dg-column>
                    <clr-dg-column [clrDgField]="'name'">Bezeichnung</clr-dg-column>
                    <clr-dg-column [clrDgField]="'technical_drawing'">Zeichnungsnummer</clr-dg-column>
                    <clr-dg-column>Material</clr-dg-column>
                    <clr-dg-column [clrDgField]="'serial_nr'">Kennzeichnung</clr-dg-column>
                    <clr-dg-column>Bemerkung</clr-dg-column>
                    <clr-dg-column class="center">Anzahl</clr-dg-column>
                    <clr-dg-column class="currency">Angebot</clr-dg-column>
                    <clr-dg-column *ngIf="editPos > 0"></clr-dg-column>
                    <clr-dg-placeholder>We couldn't find any Position for Auftragsbestätigung {{ projectId }}.0008.{{ confirmationId }}!</clr-dg-placeholder>
                    <clr-dg-row *clrDgItems="let position of positions; index as i;" [clrDgItem]="position">
                      <clr-dg-cell>{{ position.position }}<span *ngIf="position.part != null && position.part > 0">.{{ position.part }}</span> </clr-dg-cell>
                      <clr-dg-cell [routerLink]="['/component/details', position.technical_drawing]">
                        <b>{{ position.name }}</b>
                        <clr-tooltip *ngIf="position.comment_phm">
                          <cds-icon clrTooltipTrigger role="img" shape="info-circle" size="24" aria-label="PHM comment tooltip"></cds-icon>
                          <clr-tooltip-content clrPosition="bottom-right" clrSize="md" *clrIfOpen>
                            <span>{{ position.comment_phm }}</span>
                          </clr-tooltip-content>
                        </clr-tooltip>
                        <span *ngIf="position.description"><br />{{ position.description }}</span>
                        <span *ngIf="position.taric && position.taric !== '0'"><br />(Zolltarifnummer: {{ position.taric }})</span>
                      </clr-dg-cell>
                      <clr-dg-cell [routerLink]="['/component/details', position.technical_drawing]">{{ position.technical_drawing }}</clr-dg-cell>
                      <clr-dg-cell>{{ position.material }}
                        <span class="small" *ngIf="position.heat_nr !== 'null'"><br /><br />{{ position.heat_nr }}</span>
                        <span class="small" *ngIf="position.controlling_nr !== 'null'"><br *ngIf="((!position.heat_nr) || (position.heat_nr === 'null') || (position.heat_nr === ''))" /><br />{{ position.controlling_nr }}</span>
                      </clr-dg-cell>
                      <clr-dg-cell>{{ position.serial_nr }}</clr-dg-cell>
                      <clr-dg-cell>
                        <span *ngIf="position.specification"><b>Spezifikation:</b> {{ position.specification }}<br /><br /></span>
                        <span *ngIf="position.remarks"><b>Leistungsumfang:</b> {{ position.remarks }}<br /><br /></span>
                        <span *ngIf="position.side_agreements"><b>Nebenabreden (Kunde):</b> {{ position.side_agreements }}</span>
                      </clr-dg-cell>
                      <clr-dg-cell class="center"><span *ngIf="!position.technology">{{ position.number_of_pieces }}</span></clr-dg-cell>
                      <clr-dg-cell class="right currency"><b>{{ position.selling_price | currency: 'EUR':'code':'1.2-2':'de' }}</b></clr-dg-cell>
                      <clr-dg-cell class="btn-group btn-primary btn-icon" minlength="300px" *ngIf="editPos > 0">
                        <button class="btn btn-sm" (click)="updatePositionMode(i, position.position ?? 0, position.part ?? 0)">
                          <cds-icon shape="pencil"></cds-icon>
                          <span class="clr-icon-title">Ändern</span>
                        </button>
                      </clr-dg-cell>
                    </clr-dg-row>
                    <clr-dg-footer>
                      <clr-dg-pagination #pagination [clrDgPageSize]="50">
                        <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Positionen pro Seite</clr-dg-page-size>
                        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
                        von {{positions.length}} Position(en)
                      </clr-dg-pagination>
                    </clr-dg-footer>
                  </clr-datagrid>

                  <app-confirmation-edit-position [projectId]="projectId" [confirmationId]="confirmationId" [editPosition]="positionId" [editPart]="partId" *ngIf="editPos === 2"  (updatedPosition)="updateConfirmation($event)"></app-confirmation-edit-position>

                  <br />
                  <div class="btn-group btn-sm btn-primary">
                    <button *ngIf="editPos === 0" class="btn" (click)="basic = true; createConfirmation(positions)">PDF anzeigen</button>
                  </div>
                </clr-tab-content>
              </clr-tab>
            </clr-tabs>
          </div>
        </div>
        <div class="card-footer">
          <small>Projektverantwortlich:  {{ staffFirstName }} {{ staffLastName }} ({{ confirmation.employee_phm }})</small>
        </div>
      </div>
    </div>
  </div>
</main>

<clr-modal [(clrModalOpen)]="basic" [clrModalSize]="'xl'">
  <h3 class="modal-title">Auftragsbestätigung {{ projectId }}.0008.{{ confirmationId }}</h3>
  <div id="documentContainer" class="modal-body"></div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="basic = false">Zurück</button>
    <button type=“button” class="btn btn-primary" (click)="downloadPdf(); basic = false">Download</button>
    <button type="button" class="btn btn-primary" (click)="archivePdf(); basic = false">Archivieren</button>
    <button type="button" class="btn btn-primary" (click)="printPdf(); basic = false">Drucken</button>
  </div>
</clr-modal>

<pre class="datepicker-output">
{{ selected | json }}
</pre>
